export const INITIAL = "INITIAL"
export const EMPTY = "EMPTY"
export const ERROR = "ERROR"
export const LOADED = "LOADED"
export const LOADING = "LOADING"
export const RETRYING = "RETRYING"
export const UPDATING = "UPDATING"
